import { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';

function BackToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <button
        onClick={scrollToTop}
        className="flex items-center space-x-2 bg-cogCyan hover:bg-cogCyan2 text-white px-4 py-2.5 rounded-full text-xs font-medium tracking-wide shadow-md transition-all"
      >
        <ChevronUp className="w-4 h-4" />
        <span>Top</span>
      </button>
    </div>
  );
}

export default BackToTopButton;
